const e = {
  bg: "white",
  border: (r) => r.border(0.5, "lightGray3"),
  "& ": (r) => ({
    ...r.inheritIconColor()
  }),
  "&:focus-visible": (r) => ({
    ...r.outline({ color: "primary", offset: 0.75, radius: "md" })
  }),
  ":hover": {
    bg: "lightGray3",
    border: (r) => r.border(0.5, "lightGray3")
  },
  ":disabled": {
    bg: "cardOverlay",
    border: (r) => r.border(0.5, "cardOverlay")
  },
  '&[data-state="checked"]': {
    bg: "primary",
    border: (r) => r.border(0.5, "primary"),
    ":hover": {
      bg: "black",
      border: (r) => r.border(0.5, "black")
    },
    ":disabled": {
      bg: "lightGray3",
      border: (r) => r.border(0.5, "lightGray3")
    }
  }
};
export {
  e as checkboxStyles
};
